(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('numerals-arabic')) return;
  var MAP = '٠١٢٣٤٥٦٧٨٩';
  var RE = /[0-9]/;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, CODE: 1, PRE: 1, NOSCRIPT: 1, svg: 1, SVG: 1 };
  function conv(s) { return s.replace(/[0-9]/g, function (d) { return MAP[d]; }); }
  function skip(node) {
    var p = node.parentNode;
    while (p && p.nodeType === 1) {
      if (SKIP[p.nodeName] || p.hasAttribute('data-latin') || p.isContentEditable) return true;
      p = p.parentNode;
    }
    return false;
  }
  var PRICE_LATIN = root.classList.contains('price-latin');
  var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '';
  var SYM = fmt.replace(/<[^>]*>/g, '').replace(/\{\{[^}]*\}\}/g, '').trim();
  function isPrice(node) {
    if (!PRICE_LATIN) return false;
    if (SYM && node.nodeValue.indexOf(SYM) > -1) return true;
    var p = node.parentNode;
    return !!(p && p.closest && p.closest('.price, [data-product-price], .price__value, .price__compare'));
  }
  function fixText(node) {
    if (node.nodeValue && RE.test(node.nodeValue) && !skip(node) && !isPrice(node)) node.nodeValue = conv(node.nodeValue);
  }
  function walk(el) {
    if (el.nodeType === 3) { fixText(el); return; }
    if (el.nodeType !== 1) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n; while ((n = w.nextNode())) fixText(n);
    if (el.querySelectorAll) el.querySelectorAll('[placeholder]').forEach(function (i) { var v = i.getAttribute('placeholder'); if (RE.test(v)) i.setAttribute('placeholder', conv(v)); });
  }
  function start() {
    walk(document.body);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'characterData') fixText(m.target);
        else m.addedNodes.forEach(walk);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
